import React, { useState } from "react";
import Slider from "react-slick";
import { motion } from "framer-motion";
import { Typewriter } from "react-simple-typewriter";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "./OurClientCarousel.css";

import c1 from "../../Images/balcony.jpg";
import c2 from "../../Images/balcony.jpg";
import c3 from "../../Images/balcony.jpg";
import c4 from "../../Images/balcony.jpg";
import c5 from "../../Images/balcony.jpg";

const testimonials = [
  { image: c1, text: "The attention to detail and commitment...", name: "Arjun Sharma", location: "Mumbai, India" },
  { image: c2, text: "We found our dream home...", name: "Priya & Rohit", location: "Kolkata, India" },
  { image: c3, text: "Professional and trustworthy...", name: "Sofia Menon", location: "Bangalore, India" },
  { image: c4, text: "Their expertise is remarkable...", name: "Aman Verma", location: "Hyderabad, India" },
  { image: c5, text: "Highly recommended...", name: "Karan Patel", location: "Pune, India" },
];

export default function TestimonialCarousel() {
  const [active, setActive] = useState(0);

  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 800,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3500,
    beforeChange: (_, next) => setActive(next),
  };

  return (
    <div className="testimonial-section">
      <h2 className="testimonial-title">What Our Clients Say</h2>

      <Slider {...settings} className="testimonial-slider">
        {testimonials.map((item, index) => (
          <div key={index} className="testimonial-card">
            <motion.img
              src={item.image}
              alt={item.name}
              className="client-img"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.8 }}
            />

            <p className="testimonial-text">
              <Typewriter
                key={active} // 🔥 reset typing on slide change
                words={[item.text]}
                cursor={false}
                typeSpeed={40}
                deleteSpeed={10}
                delaySpeed={1500}
              />
            </p>

            <h4 className="client-name">{item.name}</h4>
            <p className="client-location">{item.location}</p>
          </div>
        ))}
      </Slider>
    </div>
  );
}
